const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Experimental Setup — Instrumentation Chain ─────────
function DiagramInstrumentationChain() {
  const W = 900, H = 310;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Vibration Measurement Instrumentation Chain — From Structure to Data</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="ic1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b"/>
          </marker>
          <marker id="ic2" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#2E75B6"/>
          </marker>
        </defs>

        {/* Structure block */}
        <rect x={14} y={80} width={100} height={70} rx={5} fill="#fff5f5" stroke="#c0392b" strokeWidth="2"/>
        <text x={64} y={110} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Structure</text>
        <text x={64} y={126} textAnchor="middle" fontSize="10" fill="#555">under test</text>
        {/* Vibration wavy lines */}
        {[0,1,2].map(i=>(
          <path key={i} d={`M ${22+i*26} 155 q 6,-8 12,0 q 6,8 12,0`} fill="none" stroke="#c0392b" strokeWidth="1.5" opacity="0.5"/>
        ))}

        {/* Arrow */}
        <line x1={114} y1={115} x2={154} y2={115} stroke="#c0392b" strokeWidth="2" markerEnd="url(#ic1)"/>

        {/* Excitation source block */}
        <rect x={154} y={80} width={110} height={70} rx={5} fill="#fff9e6" stroke="#e07b00" strokeWidth="2"/>
        <text x={209} y={106} textAnchor="middle" fontSize="11" fill="#7a4800" fontWeight="700">Excitation</text>
        <text x={209} y={120} textAnchor="middle" fontSize="10" fill="#555">Modal hammer</text>
        <text x={209} y={133} textAnchor="middle" fontSize="10" fill="#555">Shaker / EMS</text>
        <text x={209} y={146} textAnchor="middle" fontSize="10" fill="#555">Random / swept</text>

        <line x1={264} y1={115} x2={304} y2={115} stroke="#c0392b" strokeWidth="2" markerEnd="url(#ic1)"/>

        {/* Sensor block */}
        <rect x={304} y={80} width={110} height={70} rx={5} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="2"/>
        <text x={359} y={106} textAnchor="middle" fontSize="11" fill="#1a4a7a" fontWeight="700">Transducer</text>
        <text x={359} y={120} textAnchor="middle" fontSize="10" fill="#555">Accelerometer</text>
        <text x={359} y={133} textAnchor="middle" fontSize="10" fill="#555">Velocity probe</text>
        <text x={359} y={146} textAnchor="middle" fontSize="10" fill="#555">Laser vibrometer</text>

        <line x1={414} y1={115} x2={454} y2={115} stroke="#c0392b" strokeWidth="2" markerEnd="url(#ic1)"/>

        {/* Signal conditioning */}
        <rect x={454} y={80} width={110} height={70} rx={5} fill="#f0fff4" stroke="#27ae60" strokeWidth="2"/>
        <text x={509} y={106} textAnchor="middle" fontSize="11" fill="#0d4a2a" fontWeight="700">Signal Cond.</text>
        <text x={509} y={120} textAnchor="middle" fontSize="10" fill="#555">ICP/IEPE supply</text>
        <text x={509} y={133} textAnchor="middle" fontSize="10" fill="#555">Charge amplifier</text>
        <text x={509} y={146} textAnchor="middle" fontSize="10" fill="#555">Anti-alias filter</text>

        <line x1={564} y1={115} x2={604} y2={115} stroke="#c0392b" strokeWidth="2" markerEnd="url(#ic1)"/>

        {/* DAQ block */}
        <rect x={604} y={80} width={110} height={70} rx={5} fill="#f8f0ff" stroke="#9b59b6" strokeWidth="2"/>
        <text x={659} y={106} textAnchor="middle" fontSize="11" fill="#5b2c6f" fontWeight="700">DAQ / ADC</text>
        <text x={659} y={120} textAnchor="middle" fontSize="10" fill="#555">Sample & hold</text>
        <text x={659} y={133} textAnchor="middle" fontSize="10" fill="#555">fₛ ≥ 2f_max</text>
        <text x={659} y={146} textAnchor="middle" fontSize="10" fill="#555">16–24 bit res.</text>

        <line x1={714} y1={115} x2={754} y2={115} stroke="#c0392b" strokeWidth="2" markerEnd="url(#ic1)"/>

        {/* Analysis block */}
        <rect x={754} y={80} width={128} height={70} rx={5} fill="#FEF0F0" stroke="#c0392b" strokeWidth="2"/>
        <text x={818} y={106} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">Analysis</text>
        <text x={818} y={120} textAnchor="middle" fontSize="10" fill="#555">FFT / DFT</text>
        <text x={818} y={133} textAnchor="middle" fontSize="10" fill="#555">FRF estimation</text>
        <text x={818} y={146} textAnchor="middle" fontSize="10" fill="#555">Modal extraction</text>

        {/* Bottom annotation row */}
        {[
          { x:14,  label:'①', desc:'Mechanical\ndomain' },
          { x:154, label:'②', desc:'Input force\nmeasurement' },
          { x:304, label:'③', desc:'Physical →\nelectrical' },
          { x:454, label:'④', desc:'Electrical\nconditioning' },
          { x:604, label:'⑤', desc:'Analogue →\ndigital' },
          { x:754, label:'⑥', desc:'Digital signal\nprocessing' },
        ].map(({ x, label, desc }) => (
          <g key={x}>
            <text x={x+55} y={170} textAnchor="middle" fontSize="13" fill="#c0392b" fontWeight="700">{label}</text>
            {desc.split('\n').map((d, i) => (
              <text key={i} x={x+55} y={185+i*13} textAnchor="middle" fontSize="9.5" fill="#777">{d}</text>
            ))}
          </g>
        ))}

        {/* Key parameters strip */}
        <rect x={14} y={222} width={868} height={76} rx={4} fill="#fff" stroke="#f0cece"/>
        <text x={448} y={240} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">Critical Chain Parameters</text>
        {[
          { x:40,  items:['Frequency range', 'f_max ← Nyquist', 'fₛ ≥ 2.56·f_max'] },
          { x:190, items:['Dynamic range', 'Signal-to-noise', '≥ 80 dB target'] },
          { x:340, items:['Sensitivity', '[mV/g] or [pC/g]', 'Match expected amplitude'] },
          { x:490, items:['Mass loading', 'sensor mass/struct.', '< 10% at each point'] },
          { x:640, items:['Linearity', 'Check: F vs. x', 'Coherence γ² ≥ 0.9'] },
          { x:790, items:['Averaging', 'H₁, H₂, Hᵥ', 'n ≥ 5–10 averages'] },
        ].map(({ x, items }) => (
          <g key={x}>
            <text x={x} y={255} fontSize="10" fill="#c0392b" fontWeight="700">{items[0]}</text>
            <text x={x} y={268} fontSize="9.5" fill="#555">{items[1]}</text>
            <text x={x} y={281} fontSize="9.5" fill="#555">{items[2]}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The complete vibration measurement chain from structure to data. Every stage introduces potential error: the transducer has a finite frequency range and mass loading effect; signal conditioning must supply power to IEPE sensors and cut aliased frequencies; the DAQ must sample at least 2.56× the maximum frequency of interest to satisfy Nyquist and allow for anti-alias filter roll-off. Each link must be characterised to trust the final frequency response.</div>
    </div>
  );
}

// ── Diagram 2: Sensor Types — Accelerometer anatomy + comparison ──
function DiagramSensors() {
  const W = 900, H = 320;
  const PW = (W - 30) / 2;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Vibration Transducers — Accelerometer Anatomy and Sensor Comparison</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="s1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b"/>
          </marker>
        </defs>

        {/* Panel 1: Piezoelectric accelerometer cross-section */}
        <rect x={10} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10 + PW / 2} y={29} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Piezoelectric Accelerometer — Internal Structure</text>

        {/* Housing */}
        <rect x={90} y={50} width={240} height={180} rx={6} fill="#f5f5f5" stroke="#555" strokeWidth="2.5"/>
        {/* Base */}
        <rect x={90} y={200} width={240} height={30} rx={3} fill="#ccc" stroke="#555" strokeWidth="2"/>
        <text x={210} y={220} textAnchor="middle" fontSize="10" fill="#555" fontWeight="700">Base / Mounting surface</text>

        {/* Seismic mass */}
        <rect x={120} y={80} width={180} height={60} rx={4} fill="#c0392b" opacity="0.8"/>
        <text x={210} y={115} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">Seismic Mass  m</text>

        {/* Piezo crystal */}
        <rect x={130} y={143} width={160} height={20} rx={2} fill="#2E75B6" opacity="0.85"/>
        <text x={210} y={157} textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">Piezoelectric crystal</text>

        {/* Preload screw */}
        <rect x={198} y={60} width={24} height={22} rx={2} fill="#e07b00"/>
        <text x={210} y={75} textAnchor="middle" fontSize="9" fill="#fff">Bolt</text>

        {/* Spring symbol under mass */}
        {[0,1,2,3].map(i => (
          <line key={i} x1={160 + i*20} y1={140} x2={172 + i*20} y2={145} stroke="#27ae60" strokeWidth="1.5"/>
        ))}
        <text x={210} y={138} textAnchor="middle" fontSize="9" fill="#27ae60">preload spring</text>

        {/* Cable */}
        <line x1={330} y1={130} x2={370} y2={130} stroke="#555" strokeWidth="3"/>
        <text x={375} y={134} fontSize="10" fill="#555">coax cable</text>

        {/* Annotation arrows */}
        {[
          { ax:90, ay:110, bx:50, by:110, label:'Housing', sub:'protects from env.' },
          { ax:90, ay:155, bx:50, by:155, label:'Crystal', sub:'generates charge' },
          { ax:210, ay:200, bx:210, by:260, label:'Mount', sub:'stud / wax / magnet' },
        ].map(({ ax, ay, bx, by, label, sub }) => (
          <g key={label}>
            <line x1={ax} y1={ay} x2={bx+36} y2={by} stroke="#c0392b" strokeWidth="1.2" strokeDasharray="4,2" markerEnd="url(#s1)"/>
            <text x={bx-2} y={by-3} fontSize="10" fill="#c0392b" fontWeight="700" textAnchor="end">{label}</text>
            <text x={bx-2} y={by+10} fontSize="9" fill="#777" textAnchor="end">{sub}</text>
          </g>
        ))}

        {/* Frequency range sketch */}
        <rect x={90} y={265} width={240} height={35} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={210} y={280} textAnchor="middle" fontSize="10" fill="#7B0D0D" fontWeight="700">Usable range: 0.5 Hz – 10 kHz (typical)</text>
        <text x={210} y={293} textAnchor="middle" fontSize="9.5" fill="#555">Resonance f_n ~ 20–50 kHz; use below f_n/3</text>

        {/* Panel 2: Sensor comparison table */}
        <rect x={PW + 20} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW + 20 + PW / 2} y={29} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Sensor Type Comparison</text>

        {(() => {
          const cols = ['Sensor', 'Meas.', 'Range', 'Pros', 'Cons'];
          const cw = [(PW-10)/5, (PW-10)/5, (PW-10)/5, (PW-10)/5*1.2, (PW-10)/5*0.8];
          const rows2 = [
            ['Piezo\nAccel.', 'Accel.', '0.5Hz–\n10kHz', 'Robust,\nno power', 'No DC\nresponse'],
            ['MEMS\nAccel.', 'Accel.', 'DC–\n1kHz', 'Tiny,\ncheap', 'High\nnoise'],
            ['Veloc.\nProbe', 'Veloc.', '2Hz–\n2kHz', 'No amp.\nneeded', 'Fragile\ncoil'],
            ['Laser\nVibrometer', 'Veloc.', '0–\n20MHz', 'No mass\nloading', 'Cost,\nalignment'],
            ['Strain\nGauge', 'Strain', 'DC–\n1kHz', 'Cheap,\nsmall', 'Gluing,\ncreep'],
            ['Cap.\nProbe', 'Disp.', 'DC–\n10kHz', 'Non-\ncontact', 'Close\nrange'],
          ];
          const ox = PW + 24, oy = 38;
          return (
            <g>
              {/* Header */}
              {cols.map((c, ci) => {
                const cx2 = cw.slice(0,ci).reduce((a,b)=>a+b,ox);
                return (
                  <g key={ci}>
                    <rect x={cx2} y={oy} width={cw[ci]-2} height={22} fill="#c0392b"/>
                    <text x={cx2+4} y={oy+14} fontSize="10" fill="#fff" fontWeight="700">{c}</text>
                  </g>
                );
              })}
              {/* Rows */}
              {rows2.map((row, ri) => {
                const ry = oy + 22 + ri*40;
                const bg = ri%2===0 ? '#fff5f5' : '#fff';
                return row.map((cell, ci) => {
                  const cx2 = cw.slice(0,ci).reduce((a,b)=>a+b,ox);
                  return (
                    <g key={`${ri}-${ci}`}>
                      <rect x={cx2} y={ry} width={cw[ci]-2} height={38} fill={ci===0?'#FEF0F0':bg} stroke="#f0cece" strokeWidth="0.5"/>
                      {cell.split('\n').map((line, li) => (
                        <text key={li} x={cx2+4} y={ry+14+li*13} fontSize="9.5"
                          fill={ci===0?'#7B0D0D':'#333'} fontWeight={ci===0?'700':'400'}>{line}</text>
                      ))}
                    </g>
                  );
                });
              })}
            </g>
          );
        })()}

        {/* Mounting note */}
        <rect x={PW + 24} y={H - 44} width={PW - 14} height={30} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={PW + 30} y={H - 30} fontSize="10" fill="#7B0D0D" fontWeight="700">Mounting method affects upper freq. limit:</text>
        <text x={PW + 30} y={H - 18} fontSize="9.5" fill="#555">Stud bolt ≫ Adhesive wax ≫ Magnet ≫ Hand-held probe</text>
      </svg>
      <div style={S.dCaption}>The piezoelectric accelerometer is the workhorse of vibration measurement: it converts inertial force (mass × acceleration) into an electric charge via the piezoelectric effect. The seismic mass presses against the crystal; acceleration creates a proportional charge. The sensor's own resonance sets a hard upper frequency limit — use no more than one-third of the mounted resonant frequency for amplitude accuracy within ±1 dB.</div>
    </div>
  );
}

// ── Diagram 3: Modal Hammer Test Setup ────────────────────────────
function DiagramHammerTest() {
  const W = 900, H = 320;
  const PW = (W - 30) / 2;

  // Force pulse time signal
  const nPts = 80;
  const tForce = Array.from({length: nPts}, (_, i) => i / nPts * 20);
  const forceY = tForce.map(t => {
    if (t < 1) return Math.exp(-8*(t-0.4)*(t-0.4)) * 120;
    return 0;
  });

  // Spectrum of force pulse (flat up to corner then roll-off)
  const freqF = Array.from({length: nPts}, (_, i) => i / nPts * 5);
  const specF = freqF.map(f => 100 - 20 * Math.log10(1 + (f/1.5)**4));

  const ox = 14, oy = 280, ow = PW - 26, oh = 190;
  const mapX = (t, tmax) => ox + (t/tmax)*ow;
  const mapY = (v, scale) => oy - (v/scale)*oh;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Impact Hammer Test — Setup, Force Pulse, and Tip Selection</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="ht1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b"/>
          </marker>
          <marker id="ht2" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#888"/>
          </marker>
        </defs>

        {/* Panel 1: Hammer test setup drawing */}
        <rect x={10} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10 + PW / 2} y={29} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Impact Hammer Test — Roving Hammer Method</text>

        {/* Structure (beam) */}
        <rect x={40} y={150} width={320} height={22} rx={3} fill="#ddd" stroke="#888" strokeWidth="2"/>
        <text x={200} y={163} textAnchor="middle" fontSize="10" fill="#555">Test Structure (free-free or supported)</text>

        {/* Supports (soft rubber bands) */}
        {[60, 300].map(x => (
          <g key={x}>
            <line x1={x} y1={150} x2={x} y2={120} stroke="#27ae60" strokeWidth="2" strokeDasharray="4,3"/>
            <text x={x} y={115} textAnchor="middle" fontSize="9" fill="#27ae60">soft\nsusp.</text>
          </g>
        ))}

        {/* Fixed accelerometer */}
        <rect x={225} y={128} width={30} height={22} rx={2} fill="#2E75B6"/>
        <text x={240} y={142} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">ACC</text>
        <line x1={255} y1={139} x2={290} y2={139} stroke="#2E75B6" strokeWidth="1.5"/>
        <text x={295} y={143} fontSize="9" fill="#2E75B6">to DAQ</text>

        {/* Hammer at 3 positions */}
        {[70, 160, 290].map((x, i) => (
          <g key={x}>
            {/* Hammer body */}
            <rect x={x-8} y={90} width={16} height={44} rx={3} fill={i===1?'#c0392b':'#aaa'} opacity={i===1?1:0.5}/>
            <rect x={x-5} y={88} width={10} height={8} rx={1} fill={i===1?'#7B0D0D':'#888'} opacity={i===1?1:0.5}/>
            {/* Impact arrow */}
            <line x1={x} y1={134} x2={x} y2={152} stroke={i===1?'#c0392b':'#bbb'} strokeWidth={i===1?2.5:1.5}
              strokeDasharray={i===1?'none':'4,3'} markerEnd="url(#ht1)" opacity={i===1?1:0.4}/>
            <text x={x} y={82} textAnchor="middle" fontSize="9" fill={i===1?'#c0392b':'#aaa'}>F{i+1}</text>
          </g>
        ))}

        {/* Legend */}
        <text x={40} y={200} fontSize="10" fill="#c0392b" fontWeight="700">Active hit position</text>
        <text x={40} y={215} fontSize="10" fill="#aaa">Other hit positions</text>
        <rect x={40} y={223} width={320} height={28} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={47} y={237} fontSize="10" fill="#7B0D0D" fontWeight="700">Roving hammer:</text>
        <text x={47} y={250} fontSize="9.5" fill="#555">Move hammer to each DOF; keep accelerometer fixed. Reciprocity: H(i,j) = H(j,i)</text>

        {/* Force pulse time + spectrum */}
        <text x={40} y={278} fontSize="10.5" fill="#7B0D0D" fontWeight="700">Force time signal</text>
        {/* Axis */}
        <line x1={ox} y1={oy+4} x2={ox+ow+10} y2={oy+4} stroke="#bbb" strokeWidth="1.5" markerEnd="url(#ht2)"/>
        <line x1={ox} y1={oy+4} x2={ox} y2={oy-oh-6} stroke="#bbb" strokeWidth="1.5" markerEnd="url(#ht2)"/>
        {/* Pulse */}
        <polyline points={tForce.map((t,i)=>`${mapX(t,20)},${oy-forceY[i]/130*oh}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="2.5"/>
        <text x={ox+4} y={oy-oh*0.85} fontSize="9" fill="#c0392b">F(t)</text>
        <text x={ox+ow+12} y={oy+8} fontSize="9" fill="#888">ms</text>

        {/* Panel 2: Tip hardness vs. frequency + tips */}
        <rect x={PW + 20} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW + 20 + PW / 2} y={29} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Hammer Tip Hardness vs. Frequency Content</text>

        {(() => {
          const ox2 = PW + 34, oy2 = 220, ow2 = PW - 48, oh2 = 160;
          const tips = [
            { label:'Steel tip', f:4.0, col:'#c0392b', dash:'none' },
            { label:'Aluminium', f:2.5, col:'#e07b00', dash:'none' },
            { label:'Hard plastic', f:1.5, col:'#2E75B6', dash:'none' },
            { label:'Soft rubber', f:0.6, col:'#27ae60', dash:'none' },
          ];
          const nf = 80;
          return (
            <g>
              {/* Axes */}
              <line x1={ox2} y1={oy2+4} x2={ox2+ow2+10} y2={oy2+4} stroke="#bbb" strokeWidth="1.5" markerEnd="url(#ht2)"/>
              <line x1={ox2} y1={oy2+4} x2={ox2} y2={oy2-oh2-6} stroke="#bbb" strokeWidth="1.5" markerEnd="url(#ht2)"/>
              <text x={ox2+ow2+12} y={oy2+8} fontSize="9" fill="#888">kHz</text>
              <text x={ox2-6} y={oy2-oh2-8} fontSize="9" fill="#888">|F|</text>
              {[0,1,2,3,4].map(v=>(
                <g key={v}>
                  <text x={ox2+(v/4)*ow2} y={oy2+14} textAnchor="middle" fontSize="9" fill="#aaa">{v}</text>
                  <line x1={ox2+(v/4)*ow2} y1={oy2} x2={ox2+(v/4)*ow2} y2={oy2+4} stroke="#ddd" strokeWidth="1"/>
                </g>
              ))}

              {/* Tip spectra */}
              {tips.map(({ label, f, col }) => {
                const pts = Array.from({length:nf},(_,i)=>{
                  const freq = i/nf*4;
                  const mag = 1/(1+(freq/f)**6);
                  return `${ox2+(freq/4)*ow2},${oy2-mag*oh2}`;
                }).join(' ');
                return <polyline key={label} points={pts} fill="none" stroke={col} strokeWidth="2"/>;
              })}

              {/* Legend */}
              {tips.map(({ label, col }, i) => (
                <g key={i}>
                  <line x1={ox2+8} y1={oy2-oh2+24+i*18} x2={ox2+28} y2={oy2-oh2+24+i*18} stroke={col} strokeWidth="2"/>
                  <text x={ox2+32} y={oy2-oh2+28+i*18} fontSize="10" fill={col} fontWeight="700">{label}</text>
                </g>
              ))}

              {/* Tip photos / symbols */}
              {tips.map(({ label, f, col }, i) => {
                const tipX = PW + 34 + (f/4)*ow2;
                return (
                  <g key={i}>
                    <circle cx={tipX} cy={oy2-oh2*1/(1+(f/f)**6)} r={4} fill={col}/>
                  </g>
                );
              })}

              {/* Annotations */}
              <rect x={ox2} y={oy2+20} width={ow2} height={56} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
              <text x={ox2+6} y={oy2+34} fontSize="10" fill="#7B0D0D" fontWeight="700">Tip selection rule:</text>
              <text x={ox2+6} y={oy2+48} fontSize="9.5" fill="#333">Harder tip → shorter pulse → broader spectrum → higher f_max</text>
              <text x={ox2+6} y={oy2+62} fontSize="9.5" fill="#333">Softer tip → longer pulse → narrower spectrum → lower noise floor</text>
              <text x={ox2+6} y={oy2+72} fontSize="9.5" fill="#333">Double-hit check: only ONE force pulse visible per strike</text>
            </g>
          );
        })()}
      </svg>
      <div style={S.dCaption}>The impact hammer test is the most common laboratory modal testing technique. A force-instrumented hammer strikes the structure at multiple points while a fixed accelerometer records the response. The hammer tip material controls the frequency content of the input: a steel tip excites high frequencies (up to ~5 kHz) but increases the risk of double impacts; a soft rubber tip concentrates energy below ~500 Hz. The roving hammer method exploits reciprocity — H(i,j) = H(j,i) — to build a full FRF matrix efficiently.</div>
    </div>
  );
}

// ── Diagram 4: FRF — H1, H2, Coherence ───────────────────────────
function DiagramFRF() {
  const W = 900, H = 380;
  const nPts = 200;
  const wn = 2.0, zeta = 0.05;
  const freqs = Array.from({length: nPts}, (_, i) => i / nPts * 5);

  const H1mag = freqs.map(w => {
    const r = w / wn;
    return 1 / Math.sqrt((1 - r*r)**2 + (2*zeta*r)**2);
  });
  const H1phase = freqs.map(w => {
    const r = w / wn;
    return -Math.atan2(2*zeta*r, 1-r*r) * 180 / Math.PI;
  });
  // Coherence: drops near resonance if noisy, perfect away
  const coherence = freqs.map(w => {
    const r = w / wn;
    const peak = Math.exp(-((r-1)**2)/0.005);
    return 1 - 0.15*peak + 0.03*Math.random();
  });

  const padL=52, padR=14, padT=30;
  const plotH = 88;
  const mapX = w => padL + (w/5)*(W - padL - padR);
  const mapMag = v => padT + plotH - Math.min(Math.max(20*Math.log10(v)+10, -60), 60)/60*plotH;
  const mapPh = v => padT + plotH*2 + 24 + (v+200)/200*plotH;
  const mapCoh = v => padT + plotH*3 + 50 + (1-v)*plotH;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Frequency Response Function (FRF) — Magnitude, Phase, and Coherence</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="frf1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888"/>
          </marker>
        </defs>

        {/* ── Magnitude ── */}
        <text x={W/2} y={padT - 8} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">Magnitude |H(ω)| (dB re: 1 m/s²/N)</text>
        {[-40,-20,-10,0,10,20].map(db => {
          const y = padT + plotH - (db+40)/80*plotH;
          return (
            <g key={db}>
              <line x1={padL} y1={y} x2={W-padR} y2={y} stroke="#f5f5f5" strokeWidth={db===0?1.5:1}/>
              <text x={padL-4} y={y+4} textAnchor="end" fontSize="9" fill="#aaa">{db}</text>
            </g>
          );
        })}
        {[0,1,2,3,4,5].map(w=>{
          const x=mapX(w);
          return <line key={w} x1={x} y1={padT} x2={x} y2={padT+plotH} stroke="#f0f0f0" strokeWidth="1"/>;
        })}
        <polyline points={freqs.map((w,i)=>`${mapX(w)},${padT+plotH-(20*Math.log10(Math.max(H1mag[i],0.001))+40)/80*plotH}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="2.5"/>
        {/* Resonance peak annotation */}
        {(() => {
          const x = mapX(wn), y = padT+plotH-(20*Math.log10(1/(2*zeta))+40)/80*plotH;
          return (
            <g>
              <circle cx={x} cy={y} r={4} fill="#c0392b"/>
              <line x1={x} y1={y} x2={x+50} y2={y-14} stroke="#c0392b" strokeWidth="1" strokeDasharray="3,2"/>
              <text x={x+52} y={y-16} fontSize="9.5" fill="#c0392b" fontWeight="700">ωₙ = {wn} rad/s, ζ={zeta}</text>
              <text x={x+52} y={y-4} fontSize="9" fill="#c0392b">Peak = 1/(2ζ) = {(1/(2*zeta)).toFixed(0)}</text>
            </g>
          );
        })()}
        <line x1={padL} y1={padT} x2={padL} y2={padT+plotH} stroke="#888" strokeWidth="1.5"/>
        <line x1={padL} y1={padT+plotH} x2={W-padR} y2={padT+plotH} stroke="#888" strokeWidth="1.5"/>

        {/* ── Phase ── */}
        <text x={W/2} y={padT+plotH+16} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">Phase ∠H(ω) (degrees)</text>
        {[-180,-90,0].map(deg=>{
          const y = mapPh(deg);
          return (
            <g key={deg}>
              <line x1={padL} y1={y} x2={W-padR} y2={y} stroke={deg===-90?'#e0e0ff':'#f5f5f5'} strokeWidth={deg===0?1.5:1}/>
              <text x={padL-4} y={y+4} textAnchor="end" fontSize="9" fill="#aaa">{deg}°</text>
            </g>
          );
        })}
        <polyline points={freqs.map((w,i)=>`${mapX(w)},${mapPh(H1phase[i])}`).join(' ')}
          fill="none" stroke="#2E75B6" strokeWidth="2.5"/>
        {/* -90° at resonance */}
        {(() => {
          const x = mapX(wn), y = mapPh(-90);
          return (
            <g>
              <circle cx={x} cy={y} r={4} fill="#2E75B6"/>
              <text x={x+8} y={y-6} fontSize="9.5" fill="#2E75B6" fontWeight="700">−90° at ωₙ</text>
            </g>
          );
        })()}
        <line x1={padL} y1={padT+plotH+24} x2={padL} y2={padT+plotH*2+24} stroke="#888" strokeWidth="1.5"/>
        <line x1={padL} y1={padT+plotH*2+24} x2={W-padR} y2={padT+plotH*2+24} stroke="#888" strokeWidth="1.5"/>

        {/* ── Coherence ── */}
        <text x={W/2} y={padT+plotH*2+42} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">Coherence γ²(ω) — Quality Indicator</text>
        {[0,0.5,1].map(v=>{
          const y=mapCoh(v);
          return (
            <g key={v}>
              <line x1={padL} y1={y} x2={W-padR} y2={y} stroke="#f5f5f5" strokeWidth={v===1?1.5:1}/>
              <text x={padL-4} y={y+4} textAnchor="end" fontSize="9" fill="#aaa">{v.toFixed(1)}</text>
            </g>
          );
        })}
        {/* Threshold line 0.9 */}
        <line x1={padL} y1={mapCoh(0.9)} x2={W-padR} y2={mapCoh(0.9)} stroke="#e07b00" strokeWidth="1.2" strokeDasharray="5,3"/>
        <text x={W-padR-2} y={mapCoh(0.9)-3} textAnchor="end" fontSize="9" fill="#e07b00">γ²=0.9 threshold</text>
        <polyline points={freqs.map((w,i)=>`${mapX(w)},${mapCoh(coherence[i])}`).join(' ')}
          fill="none" stroke="#27ae60" strokeWidth="2"/>
        <line x1={padL} y1={padT+plotH*3+50} x2={padL} y2={padT+plotH*4+50} stroke="#888" strokeWidth="1.5"/>
        <line x1={padL} y1={padT+plotH*4+50} x2={W-padR} y2={padT+plotH*4+50} stroke="#888" strokeWidth="1.5"/>

        {/* Frequency axis label */}
        <text x={W/2} y={H-2} textAnchor="middle" fontSize="10" fill="#888">Frequency (rad/s)</text>
        {[0,1,2,3,4,5].map(w=>(
          <text key={w} x={mapX(w)} y={H-4} textAnchor="middle" fontSize="9" fill="#aaa">{w}</text>
        ))}

        {/* H1, H2 labels */}
        <rect x={padL+8} y={padT+4} width={200} height={22} rx={2} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={padL+14} y={padT+18} fontSize="9.5" fill="#7B0D0D" fontWeight="700">H₁=Sxy/Sxx  (min. input noise);  H₂=Syy/Syx  (min. output noise)</text>
      </svg>
      <div style={S.dCaption}>The Frequency Response Function H(ω) = X(ω)/F(ω) is the primary result of any vibration test. Magnitude peaks reveal natural frequencies; the phase passes through −90° exactly at each resonance. Coherence γ²(ω) = |Sxy|²/(Sxx·Syy) measures the linear causality between input and output — a value below 0.9 indicates noise, nonlinearity, or signal leakage. H₁ minimises the effect of output noise; H₂ minimises input noise; Hᵥ is a geometric mean used when noise is present at both.</div>
    </div>
  );
}

// ── Diagram 5: Modal Analysis — SDOF circle fit ───────────────────
function DiagramModalAnalysis() {
  const W = 900, H = 330;
  const PW = (W - 30) / 2;

  // SDOF Nyquist circle: Im vs Re of H(ω) near resonance
  const wn = 2.0, zeta = 0.06;
  const wRange = Array.from({length: 80}, (_, i) => 1.2 + i/79*1.6);
  const circPts = wRange.map(w => {
    const r = w/wn;
    const real = (1-r*r)/((1-r*r)**2+(2*zeta*r)**2);
    const imag = -(2*zeta*r)/((1-r*r)**2+(2*zeta*r)**2);
    return { real, imag, w };
  });

  const cx1 = 10 + PW/2, cy1 = 165, sc = 26;

  // Mode shape visualisation
  const beam_x = Array.from({length:6},(_,i)=>i/5);
  const modes = [
    { shape:[0,0.5,0.87,1.0,0.87,0.5], col:'#c0392b', label:'Mode 1' },
    { shape:[0,0.87,0.87,0,-.87,-.87], col:'#2E75B6', label:'Mode 2' },
    { shape:[0,1.0,0,-.87,.5,1.0],     col:'#27ae60', label:'Mode 3' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Modal Analysis — SDOF Circle Fit and Mode Shapes</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="ma1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888"/>
          </marker>
        </defs>

        {/* Panel 1: Nyquist circle (SDOF) */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={cx1} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">SDOF Nyquist Circle — FRF in Im vs. Re Plane</text>

        {/* Axes */}
        <line x1={10+14} y1={cy1} x2={10+PW-10} y2={cy1} stroke="#ddd" strokeWidth="1.5" markerEnd="url(#ma1)"/>
        <line x1={cx1} y1={H-24} x2={cx1} y2={16} stroke="#ddd" strokeWidth="1.5" markerEnd="url(#ma1)"/>
        <text x={10+PW-12} y={cy1+13} fontSize="10" fill="#aaa">Re(H)</text>
        <text x={cx1+4} y={18} fontSize="10" fill="#aaa">Im(H)</text>

        {/* The circle */}
        <ellipse cx={cx1} cy={cy1+sc/(2*zeta)*0.5} rx={sc/(2*zeta)*0.5}
          ry={sc/(2*zeta)*0.5} fill="none" stroke="#f0cece" strokeWidth="1" strokeDasharray="5,3"/>

        {/* Curve */}
        <polyline points={circPts.map(({real,imag})=>`${cx1+real*sc},${cy1-imag*sc}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="2.5"/>

        {/* Resonance point */}
        {(() => {
          const mid = circPts[Math.floor(circPts.length/2)];
          const px = cx1+mid.real*sc, py = cy1-mid.imag*sc;
          return (
            <g>
              <circle cx={px} cy={py} r={5} fill="#c0392b" stroke="#fff" strokeWidth="1.5"/>
              <line x1={px} y1={py} x2={px+30} y2={py-30} stroke="#c0392b" strokeWidth="1" strokeDasharray="3,2"/>
              <text x={px+32} y={py-32} fontSize="10" fill="#c0392b" fontWeight="700">ωₙ (resonance)</text>
              <text x={px+32} y={py-20} fontSize="9" fill="#c0392b">Im(H) = max</text>
            </g>
          );
        })()}

        {/* -3dB points */}
        {[circPts[15], circPts[64]].map(({real,imag,w},i)=>{
          const px=cx1+real*sc, py=cy1-imag*sc;
          return (
            <g key={i}>
              <circle cx={px} cy={py} r={4} fill="#2E75B6"/>
              <text x={px+(i===0?-8:8)} y={py+14} textAnchor={i===0?'end':'start'}
                fontSize="9" fill="#2E75B6">ω{i===0?'a':'b'}={w.toFixed(2)}</text>
            </g>
          );
        })}

        {/* Damping formula */}
        <rect x={14} y={H-80} width={PW-18} height={56} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={20} y={H-66} fontSize="10.5" fill="#7B0D0D" fontWeight="700">Half-power bandwidth method:</text>
        <text x={20} y={H-52} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">ζ = (ωb² − ωa²) / (2ωn²)  ≈  (ωb − ωa) / (2ωn)</text>
        <text x={20} y={H-38} fontSize="10" fill="#333">ωa, ωb = frequencies where |H|=|H|_max/√2 (−3 dB points)</text>
        <text x={20} y={H-25} fontSize="9.5" fill="#555">Circle fit: diameter of SDOF Nyquist circle = 1/(2ζωₙ²·m)</text>

        {/* Panel 2: Mode shapes */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20+PW/2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Mode Shapes — Beam First Three Modes</text>

        {(() => {
          const ox=PW+28, baseY=250, beamW=PW-40, sc2=60;
          return (
            <g>
              {/* Undeformed beam */}
              <line x1={ox} y1={baseY} x2={ox+beamW} y2={baseY} stroke="#ddd" strokeWidth="1.5" strokeDasharray="5,3"/>
              <text x={ox} y={baseY+14} fontSize="9" fill="#aaa">undeformed</text>

              {modes.map(({shape,col,label},mi)=>{
                const pts=beam_x.map((x,i)=>`${ox+x*beamW},${baseY-shape[i]*sc2}`).join(' ');
                return (
                  <g key={mi}>
                    <polyline points={pts} fill="none" stroke={col} strokeWidth="2.5"/>
                    {beam_x.map((x,i)=>(
                      <circle key={i} cx={ox+x*beamW} cy={baseY-shape[i]*sc2} r={3.5} fill={col}/>
                    ))}
                    <text x={ox+beamW+6} y={baseY-shape[5]*sc2+4} fontSize="10" fill={col} fontWeight="700">{label}</text>
                  </g>
                );
              })}

              {/* Node point labels for mode 2 */}
              {[0.5].map(x => (
                <g key={x}>
                  <circle cx={ox+x*beamW} cy={baseY} r={4} fill="#2E75B6" opacity="0.7"/>
                  <text x={ox+x*beamW} y={baseY-8} textAnchor="middle" fontSize="9" fill="#2E75B6">node</text>
                </g>
              ))}

              {/* MAC matrix sketch */}
              <text x={ox} y={46} fontSize="11" fill="#7B0D0D" fontWeight="700">MAC Matrix (Modal Assurance Criterion)</text>
              {[0,1,2].map(i=>[0,1,2].map(j=>{
                const mac = i===j ? 1.0 : (i===0&&j===1?0.02:i===1&&j===2?0.03:0.01);
                const fill = i===j?'#c0392b':'#eee';
                const mx=ox+20+j*52, my=56+i*34;
                return (
                  <g key={`${i}-${j}`}>
                    <rect x={mx} y={my} width={48} height={30} rx={2} fill={fill} stroke="#f0cece" strokeWidth="0.5" opacity={i===j?0.9:0.5}/>
                    <text x={mx+24} y={my+19} textAnchor="middle" fontSize={i===j?'12':'10'}
                      fill={i===j?'#fff':'#999'} fontWeight={i===j?'700':'400'}>{mac.toFixed(2)}</text>
                  </g>
                );
              }))}
              {[0,1,2].map(i=>(
                <g key={i}>
                  <text x={ox+10} y={72+i*34} textAnchor="end" fontSize="9" fill="#c0392b">φ{i+1}</text>
                  <text x={ox+20+i*52+24} y={53} textAnchor="middle" fontSize="9" fill="#c0392b">φ{i+1}</text>
                </g>
              ))}
              <text x={ox+10} y={190} fontSize="9.5" fill="#555">Diagonal=1 → orthogonal modes ✓</text>
              <text x={ox+10} y={204} fontSize="9.5" fill="#555">Off-diagonal≈0 → modes are independent</text>
            </g>
          );
        })()}
      </svg>
      <div style={S.dCaption}>The SDOF Nyquist circle plot maps the complex FRF H(ω) onto the Im–Re plane; a single mode traces out a circle. The resonant frequency is at the point where the arc sweeps fastest (maximum imaginary part). The half-power bandwidth Δω = ωb − ωa gives damping ζ ≈ Δω/(2ωₙ). Mode shapes describe the spatial pattern of vibration at each natural frequency; the MAC matrix quantifies their linear independence — diagonal unity confirms orthogonality.</div>
    </div>
  );
}

// ── Diagram 6: Signal Processing — FFT, Windowing, Aliasing ───────
function DiagramSignalProcessing() {
  const W = 900, H = 340;
  const PW = (W - 30) / 2;
  const N = 64;

  // Time signals
  const t = Array.from({length: N}, (_, i) => i / N * 4);
  const sig = t.map(tv => Math.sin(2*Math.PI*1.5*tv) + 0.4*Math.sin(2*Math.PI*4*tv));
  const sigTruncated = t.map((tv, i) => i < N-6 ? sig[i] : 0);

  // DFT magnitudes (approximate)
  const nFreq = N/2;
  const freqBins = Array.from({length: nFreq}, (_, k) => k*0.25);
  const dft = freqBins.map((f) => {
    let re=0, im=0;
    for (let n=0; n<N; n++) {
      re += sigTruncated[n]*Math.cos(2*Math.PI*f*t[n]);
      im -= sigTruncated[n]*Math.sin(2*Math.PI*f*t[n]);
    }
    return Math.sqrt(re*re+im*im)/N*2;
  });

  const ox1=14, oy1=120, ow=PW-28, oh=90;

  // Windows
  const hann = Array.from({length:N},(_,i) => 0.5*(1-Math.cos(2*Math.PI*i/(N-1))));
  const rect = Array.from({length:N},()=>1);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Signal Processing — FFT, Windowing, and Aliasing</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="sp1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888"/>
          </marker>
        </defs>

        {/* Panel 1 */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10+PW/2} y={27} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Windowing — Hann vs. Rectangular</text>

        {/* Time domain signals */}
        {[
          { ys:sig, col:'#c0392b', label:'Rectangular (no window)', y0:oy1 },
          { ys:sig.map((v,i)=>v*hann[i]), col:'#2E75B6', label:'Hann window applied', y0:oy1+140 },
        ].map(({ys,col,label,y0})=>(
          <g key={label}>
            <text x={ox1} y={y0-14} fontSize="10.5" fill={col} fontWeight="700">{label}</text>
            {/* Axis */}
            <line x1={ox1} y1={y0+oh/2+4} x2={ox1+ow+8} y2={y0+oh/2+4} stroke="#ddd" strokeWidth="1" markerEnd="url(#sp1)"/>
            <line x1={ox1} y1={y0-oh/2-4} x2={ox1} y2={y0+oh/2+14} stroke="#ddd" strokeWidth="1" markerEnd="url(#sp1)"/>
            {/* Signal */}
            <polyline points={ys.map((v,i)=>`${ox1+(i/N)*ow},${y0-v*oh/2}`).join(' ')}
              fill="none" stroke={col} strokeWidth="1.8"/>
            {/* Discontinuity marker for rectangular */}
            {col==='#c0392b' && (
              <g>
                <line x1={ox1} y1={y0-oh/2} x2={ox1} y2={y0+oh/2} stroke="#c0392b" strokeWidth="1" strokeDasharray="3,2" opacity="0.6"/>
                <line x1={ox1+ow} y1={y0-oh/2} x2={ox1+ow} y2={y0+oh/2} stroke="#c0392b" strokeWidth="1" strokeDasharray="3,2" opacity="0.6"/>
                <text x={ox1+ow/2} y={y0+oh/2+16} textAnchor="middle" fontSize="9" fill="#c0392b">discontinuity at edges → spectral leakage</text>
              </g>
            )}
            {col==='#2E75B6' && (
              <text x={ox1+ow/2} y={y0+oh/2+16} textAnchor="middle" fontSize="9" fill="#2E75B6">tapered to zero at edges → reduced leakage</text>
            )}
          </g>
        ))}

        {/* Panel 2 */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20+PW/2} y={27} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Aliasing — Undersampling and the Nyquist Criterion</text>

        {(() => {
          const ox2=PW+30, oy2=200, ow2=PW-40, oh2=150;
          // True signal 2 Hz, aliased version at sampling 3 Hz
          const tTrue = Array.from({length:100},(_,i)=>i/99*3);
          const trueY = tTrue.map(tv => Math.sin(2*Math.PI*2*tv));
          // Sampled at fs=3 → alias at 1 Hz
          const sampleT = [0, 1/3, 2/3, 1, 4/3, 5/3, 2, 7/3, 8/3, 3];
          const sampleY = sampleT.map(tv => Math.sin(2*Math.PI*2*tv));
          // Aliased: 1 Hz reconstruction
          const aliasY = tTrue.map(tv => Math.sin(2*Math.PI*1*tv));

          return (
            <g>
              {/* Axes */}
              <line x1={ox2} y1={oy2+4} x2={ox2+ow2+8} y2={oy2+4} stroke="#ddd" strokeWidth="1.5" markerEnd="url(#sp1)"/>
              <line x1={ox2} y1={oy2+4} x2={ox2} y2={oy2-oh2-8} stroke="#ddd" strokeWidth="1.5" markerEnd="url(#sp1)"/>
              <text x={ox2+ow2+10} y={oy2+8} fontSize="9" fill="#888">t</text>

              {/* True 2 Hz signal */}
              <polyline points={tTrue.map((tv,i)=>`${ox2+tv/3*ow2},${oy2-trueY[i]*oh2/2}`).join(' ')}
                fill="none" stroke="#c0392b" strokeWidth="2"/>
              <text x={ox2+8} y={oy2-oh2/2-6} fontSize="9.5" fill="#c0392b" fontWeight="700">True: 2 Hz signal</text>

              {/* Aliased reconstruction */}
              <polyline points={tTrue.map((tv,i)=>`${ox2+tv/3*ow2},${oy2-aliasY[i]*oh2/2}`).join(' ')}
                fill="none" stroke="#2E75B6" strokeWidth="2" strokeDasharray="6,3"/>
              <text x={ox2+8} y={oy2+oh2*0.1} fontSize="9.5" fill="#2E75B6" fontWeight="700">Alias: 1 Hz (fₛ=3 Hz &lt; 2×2 Hz)</text>

              {/* Sample dots */}
              {sampleT.map((tv,i)=>(
                <circle key={i} cx={ox2+tv/3*ow2} cy={oy2-sampleY[i]*oh2/2} r={4} fill="#9b59b6"/>
              ))}
              <text x={ox2+8} y={oy2+oh2*0.25} fontSize="9.5" fill="#9b59b6">Sample points (shared by both!)</text>

              {/* Nyquist rule box */}
              <rect x={ox2} y={oy2+14} width={ow2} height={62} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
              <text x={ox2+6} y={oy2+28} fontSize="10.5" fill="#7B0D0D" fontWeight="700">Nyquist–Shannon Sampling Theorem:</text>
              <text x={ox2+6} y={oy2+43} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">fₛ ≥ 2·f_max   (at minimum)</text>
              <text x={ox2+6} y={oy2+57} fontSize="9.5" fill="#333">Practice: fₛ ≥ 2.56·f_max to allow anti-alias filter roll-off</text>
              <text x={ox2+6} y={oy2+70} fontSize="9.5" fill="#555">Aliased frequency: f_alias = |fₛ·round(f/fₛ) − f|</text>

              {/* Common fft sizes */}
              <rect x={ox2} y={oy2+82} width={ow2} height={42} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1"/>
              <text x={ox2+6} y={oy2+96} fontSize="10" fill="#2E75B6" fontWeight="700">Frequency resolution:  Δf = fₛ / N_FFT</text>
              <text x={ox2+6} y={oy2+111} fontSize="9.5" fill="#333">N=512→Δf=fₛ/512;  N=1024→half Δf;  N=4096→high res.</text>
              <text x={ox2+6} y={oy2+120} fontSize="9.5" fill="#555">Time resolution vs. frequency resolution are always in conflict</text>
            </g>
          );
        })()}
      </svg>
      <div style={S.dCaption}>Spectral leakage occurs when a signal does not complete an integer number of cycles within the FFT window — the apparent discontinuity at the window edges spreads energy across adjacent frequency bins. Windowing (Hann, Hamming, flat-top) tapers the record to zero at both ends, dramatically reducing leakage at the cost of slightly reduced frequency resolution. Aliasing is the irreversible misidentification of high-frequency content as low-frequency content when the sampling rate violates the Nyquist criterion.</div>
    </div>
  );
}

// ── Diagram 7: Shaker Testing & Random vs. Swept Sine ─────────────
function DiagramShakerTest() {
  const W = 900, H = 320;
  const PW = (W - 30) / 2;

  // Swept sine: frequency ramps
  const N=100;
  const tSwept = Array.from({length:N},(_,i)=>i/N*4);
  const sweptSig = tSwept.map(tv => Math.sin(2*Math.PI*(0.5+tv*1.5)*tv));

  // Broadband random
  let rand = 0;
  const randSig = Array.from({length:N},()=>{
    rand = 0.7*rand + 0.3*(Math.random()*2-1);
    return rand;
  });

  const ox=14, oy=200, ow=PW-28, oh=130;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Shaker Testing — Swept Sine vs. Broadband Random Excitation</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="sk1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888"/>
          </marker>
          <marker id="sk2" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#c0392b"/>
          </marker>
        </defs>

        {/* Panel 1: Swept sine */}
        <rect x={10} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={10+PW/2} y={27} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Swept Sine (Chirp) Excitation</text>
        <text x={10+PW/2} y={42} textAnchor="middle" fontSize="10" fill="#555">f(t) = A·sin(2π·[f₀ + (f₁−f₀)t/(2T)]·t)</text>

        <line x1={ox} y1={oy+4} x2={ox+ow+8} y2={oy+4} stroke="#ddd" strokeWidth="1.5" markerEnd="url(#sk1)"/>
        <line x1={ox} y1={oy+4} x2={ox} y2={oy-oh-8} stroke="#ddd" strokeWidth="1.5" markerEnd="url(#sk1)"/>
        <polyline points={sweptSig.map((v,i)=>`${ox+(i/N)*ow},${oy-v*oh/2}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="2"/>
        <text x={ox+ow/4} y={oy+18} fontSize="9.5" fill="#888">low f →</text>
        <text x={ox+ow*0.75} y={oy+18} fontSize="9.5" fill="#888">→ high f</text>

        {[
          { y:220, col:'#c0392b', bg:'#FEF0F0', bc:'#c0392b', title:'Advantages', items:['High SNR at each frequency','Easy to detect nonlinearity','Slow sweep → steady-state at each f'] },
          { y:268, col:'#2E75B6', bg:'#eaf3ff', bc:'#2E75B6', title:'Disadvantages', items:['Slow — long test times','Misses transient resonances if too fast','Requires stable amplitude control'] },
        ].map(({y,col,bg,bc,title,items})=>(
          <g key={y}>
            <rect x={14} y={y} width={PW-18} height={items.length*15+18} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={20} y={y+13} fontSize="10" fill={col} fontWeight="700">{title}</text>
            {items.map((it,i)=>(
              <text key={i} x={26} y={y+26+i*15} fontSize="9.5" fill="#333">• {it}</text>
            ))}
          </g>
        ))}

        {/* Panel 2: Broadband random */}
        <rect x={PW+20} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={PW+20+PW/2} y={27} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Broadband Random (White Noise / Burst)</text>
        <text x={PW+20+PW/2} y={42} textAnchor="middle" fontSize="10" fill="#555">Flat PSD: S_uu = σ² / f_max  (over bandwidth)</text>

        {(() => {
          const ox2=PW+30, ow2=PW-40;
          return (
            <g>
              <line x1={ox2} y1={oy+4} x2={ox2+ow2+8} y2={oy+4} stroke="#ddd" strokeWidth="1.5" markerEnd="url(#sk1)"/>
              <line x1={ox2} y1={oy+4} x2={ox2} y2={oy-oh-8} stroke="#ddd" strokeWidth="1.5" markerEnd="url(#sk1)"/>
              <polyline points={randSig.map((v,i)=>`${ox2+(i/N)*ow2},${oy-v*oh/2}`).join(' ')}
                fill="none" stroke="#2E75B6" strokeWidth="1.8"/>

              {/* Burst random shading */}
              <rect x={ox2+ow2*0.6} y={oy-oh} width={ow2*0.38} height={oh+4} fill="#f0fff4" opacity="0.5"/>
              <line x1={ox2+ow2*0.6} y1={oy-oh} x2={ox2+ow2*0.6} y2={oy+4} stroke="#27ae60" strokeWidth="1.5" strokeDasharray="4,2"/>
              <text x={ox2+ow2*0.79} y={oy-oh*0.85} textAnchor="middle" fontSize="9" fill="#27ae60">burst\nperiod\n(zero-padded)</text>

              {[
                { y:220, col:'#2E75B6', bg:'#eaf3ff', bc:'#2E75B6', title:'Advantages', items:['Fast — all freqs simultaneously','Easy averaging → good coherence','Stationary → easy leakage control'] },
                { y:268, col:'#c0392b', bg:'#FEF0F0', bc:'#c0392b', title:'Disadvantages', items:['Lower SNR per frequency','Cannot easily separate modes','Burst random needed to control leakage'] },
              ].map(({y,col,bg,bc,title,items})=>(
                <g key={y}>
                  <rect x={ox2} y={y} width={ow2} height={items.length*15+18} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
                  <text x={ox2+6} y={y+13} fontSize="10" fill={col} fontWeight="700">{title}</text>
                  {items.map((it,i)=>(
                    <text key={i} x={ox2+12} y={y+26+i*15} fontSize="9.5" fill="#333">• {it}</text>
                  ))}
                </g>
              ))}
            </g>
          );
        })()}
      </svg>
      <div style={S.dCaption}>Shaker testing uses an electrodynamic or hydraulic exciter driven by a power amplifier and signal generator to apply a controlled force. Swept sine is preferred when high signal-to-noise ratio at each frequency is needed and the structure is well behaved. Broadband random excitation is faster and simultaneously excites all frequencies, making it the default choice for FRF estimation with multiple averages. Burst random — a short burst followed by a zero-padded period — combines the benefits of both by allowing the response to decay before the next burst, eliminating leakage without windowing.</div>
    </div>
  );
}

// ── Diagram 8: Vibration Metrics & Standards ──────────────────────
function DiagramMetrics() {
  const W = 900, H = 320;

  // Waterfall plot: RPM sweep showing Campbell diagram-like
  const nRPM = 20, nFreq = 80;
  const rpms = Array.from({length:nRPM},(_,i)=>600+i*120);
  const freqs2 = Array.from({length:nFreq},(_,i)=>i/nFreq*200);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Vibration Metrics, Standards, and Waterfall / Campbell Diagram</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="mt1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0,6 3,0 6" fill="#888"/>
          </marker>
        </defs>

        {/* Waterfall / Campbell sketch */}
        {(() => {
          const ox=18, oy=240, ow=320, oh=180, rowH=oh/nRPM;
          return (
            <g>
              <text x={ox+ow/2} y={46} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Campbell Diagram — Order Tracking</text>

              {/* Axes */}
              <line x1={ox} y1={oy+4} x2={ox+ow+10} y2={oy+4} stroke="#888" strokeWidth="1.5" markerEnd="url(#mt1)"/>
              <line x1={ox} y1={oy+4} x2={ox} y2={oy-oh-10} stroke="#888" strokeWidth="1.5" markerEnd="url(#mt1)"/>
              <text x={ox+ow+12} y={oy+8} fontSize="9" fill="#888">f (Hz)</text>
              <text x={ox-6} y={oy-oh-12} fontSize="9" fill="#888" textAnchor="end">RPM</text>

              {/* Waterfall rows */}
              {rpms.map((rpm,ri)=>{
                const y = oy - ri*rowH;
                const order1 = rpm/60;  // 1× RPM
                const order2 = rpm/30;  // 2× RPM
                const fn = 80;          // structural mode
                const pts = freqs2.map((f,fi)=>{
                  let v = 0.08;
                  v += 0.5*Math.exp(-((f-order1)**2)/2);
                  v += 0.35*Math.exp(-((f-order2)**2)/1.5);
                  v += 0.6*Math.exp(-((f-fn)**2)/4);
                  return `${ox+(f/200)*ow},${y-v*rowH*1.4}`;
                }).join(' ');
                return <polyline key={ri} points={pts} fill="none"
                  stroke={`hsl(${200+ri*4},65%,45%)`} strokeWidth="0.8" opacity="0.85"/>;
              })}

              {/* Order lines */}
              {[1,2].map((ord,i)=>{
                const x1=ox+(rpms[0]/60*ord/200)*ow;
                const x2=ox+(rpms[nRPM-1]/60*ord/200)*ow;
                const y1=oy;
                const y2=oy-oh;
                return (
                  <g key={i}>
                    <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="5,3"/>
                    <text x={x2+2} y={y2+8} fontSize="9" fill="#c0392b" fontWeight="700">{ord}× order</text>
                  </g>
                );
              })}

              {/* Natural frequency line */}
              <line x1={ox+(80/200)*ow} y1={oy} x2={ox+(80/200)*ow} y2={oy-oh}
                stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="4,2"/>
              <text x={ox+(80/200)*ow+2} y={oy-oh+8} fontSize="9" fill="#2E75B6">fₙ</text>

              {/* Crossing annotation */}
              {[1,2].map(ord=>{
                const rpm_cross = 80*60/ord;
                if(rpm_cross<rpms[0]||rpm_cross>rpms[nRPM-1]) return null;
                const ri=(rpm_cross-rpms[0])/(rpms[nRPM-1]-rpms[0]);
                const cx2=ox+(80/200)*ow;
                const cy2=oy-ri*oh;
                return (
                  <g key={ord}>
                    <circle cx={cx2} cy={cy2} r={5} fill="#c0392b" opacity="0.8"/>
                    <text x={cx2+8} y={cy2-4} fontSize="9" fill="#c0392b" fontWeight="700">Crossing!</text>
                  </g>
                );
              })}

              <text x={ox} y={oy+18} fontSize="9" fill="#888">0</text>
              <text x={ox+ow} y={oy+18} fontSize="9" fill="#888">200</text>
            </g>
          );
        })()}

        {/* Right: Metrics cards */}
        <rect x={360} y={10} width={530} height={H-18} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={625} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Vibration Metrics and Acceptance Standards</text>

        {[
          { y:36, col:'#c0392b', bg:'#FEF0F0', bc:'#c0392b',
            title:'RMS (Root Mean Square)',
            lines:['x_rms = √(1/T ∫₀ᵀ x²dt)  or  √(Σxᵢ²/N)',
                   'Most common single-number severity measure',
                   'ISO 10816: machinery vibration limits in mm/s rms'] },
          { y:104, col:'#2E75B6', bg:'#eaf3ff', bc:'#2E75B6',
            title:'Peak and Peak-to-Peak',
            lines:['x_peak = max|x(t)|;  x_pp = max(x)−min(x)',
                   'Important for stress/fatigue and clearance checks',
                   'Crest factor = x_peak/x_rms  (sinusoid: √2 ≈ 1.41)'] },
          { y:172, col:'#27ae60', bg:'#f0fff4', bc:'#27ae60',
            title:'Power Spectral Density (PSD)',
            lines:['S_xx(f) = |X(f)|²/T  (V²/Hz or g²/Hz)',
                   'Describes how power is distributed across frequency',
                   'x_rms² = ∫ S_xx(f)df  (Parseval\'s theorem)'] },
          { y:240, col:'#e07b00', bg:'#fff9e6', bc:'#e07b00',
            title:'ISO / Standards',
            lines:['ISO 10816: shaft & bearing vibration (mm/s rms)',
                   'ISO 7919: shaft vibration (µm peak-to-peak)',
                   'ISO 5347/5348: accelerometer calibration procedures',
                   'MIL-STD-810: environmental vibration test profiles'] },
        ].map(({y,col,bg,bc,title,lines})=>(
          <g key={y}>
            <rect x={366} y={y} width={518} height={lines.length*17+20} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={372} y={y+14} fontSize="11" fill={col} fontWeight="700">{title}</text>
            {lines.map((line,i)=>(
              <text key={i} x={372} y={y+29+i*17} fontSize="9.5" fill="#333">{line}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The Campbell (waterfall) diagram plots the response spectrum at each operating speed on a 3-D waterfall. Diagonal lines trace engine orders (multiples of shaft speed); vertical lines mark structural natural frequencies. A resonance crossing — where an order line intersects a natural frequency line — creates a potentially damaging condition if the damping is low. Vibration severity is assessed by comparing RMS velocity or displacement against ISO acceptance bands for the machine class.</div>
    </div>
  );
}

// ── Diagram 9: Calibration & Error Sources ────────────────────────
function DiagramCalibration() {
  const W = 900, H = 290;
  const cols = [
    { title:'Mass Loading', col:'#c0392b', bg:'#FEF0F0', bc:'#c0392b',
      icon:'⚖',
      desc:'Accelerometer adds mass m_s to structure of mass M\nShifts natural frequency: Δfₙ/fₙ ≈ −m_s/(2M)\nRule: m_sensor < 10% of modal mass at each point' },
    { title:'Cable Noise', col:'#2E75B6', bg:'#eaf3ff', bc:'#2E75B6',
      icon:'〜',
      desc:'Triboelectric effect: charge generated by cable flexing\nUse low-noise, armoured coaxial cables\nIEPE sensors: low impedance output → less susceptible' },
    { title:'Ground Loops', col:'#27ae60', bg:'#f0fff4', bc:'#27ae60',
      icon:'⊕',
      desc:'Multiple ground paths → 50/60 Hz hum in signal\nIsolate structure from DAQ chassis ground\nUse differential inputs or isolated sensor mounts' },
    { title:'Resonance of Fixture', col:'#e07b00', bg:'#fff9e6', bc:'#e07b00',
      icon:'⟳',
      desc:'Test fixture resonances contaminate measurement\nDesign fixtures with natural frequencies > 3× test range\nCheck fixture FRF independently before test' },
    { title:'Calibration Traceability', col:'#9b59b6', bg:'#f8f0ff', bc:'#9b59b6',
      icon:'✓',
      desc:'Reference accelerometer calibrated against primary standard\nBack-to-back comparison: DUT vs. reference on same shaker\nISO 5347-3 / ANSI S2.2: reciprocity & comparison methods' },
    { title:'Nonlinearity Check', col:'#7B0D0D', bg:'#fff5f5', bc:'#c0392b',
      icon:'≠',
      desc:'Test at multiple amplitudes — FRF should not change\nCoherence < 1 at all levels → nonlinearity present\nSoftening: fₙ decreases with amplitude; hardening: fₙ increases' },
  ];
  const cardW = (W-24)/3, cardH = 110;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Common Measurement Errors, Calibration, and Quality Checks</div>
      <svg viewBox={`0 0 ${W} 248`} style={{ width:'100%', display:'block' }}>
        {cols.map(({ title, col, bg, bc, icon, desc }, i) => {
          const c = i % 3, r = Math.floor(i / 3);
          const x = 8 + c*(cardW+4), y = 8 + r*(cardH+6);
          return (
            <g key={i}>
              <rect x={x} y={y} width={cardW} height={cardH} rx={5} fill={bg} stroke={bc} strokeWidth="1.5"/>
              <rect x={x} y={y} width={cardW} height={26} rx={4} fill={bc}/>
              <text x={x+30} y={y+17} fontSize="12" fill="#fff" fontWeight="700">{title}</text>
              <text x={x+cardW-14} y={y+18} fontSize="16" fill="#fff" opacity="0.6">{icon}</text>
              {desc.split('\n').map((line,li)=>(
                <text key={li} x={x+8} y={y+40+li*18} fontSize="9.5" fill="#333">{line}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Every physical measurement is subject to systematic and random errors. Mass loading is the most insidious — it changes the very quantity being measured. Cable noise and ground loops are electrical artefacts that corrupt the signal before it reaches the ADC. Calibration traceability to national measurement standards (NIST, NPL) is required for acceptance testing. Nonlinearity checks via repeated tests at different amplitudes confirm that the linear FRF model is valid and that the measured natural frequencies are reliable.</div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────
export default function VibrationMeasurement() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Vibration Measurement &amp; Experiments</h1>
      <p style={S.p}>
        Vibration measurement transforms the mathematical models of structural dynamics into verifiable, quantitative descriptions of real physical systems. Every prediction made by a finite-element model, every natural frequency computed from a mass-stiffness matrix, must ultimately be confronted with experimental data. Vibration testing encompasses the complete workflow from choosing the right transducer and excitation strategy, through signal conditioning and analogue-to-digital conversion, to the digital signal processing algorithms that extract frequency response functions, natural frequencies, damping ratios, and mode shapes. Understanding each stage — and the errors it introduces — is essential for producing measurements that can be trusted.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "The measurement chain converts mechanical vibration into digital data through: structure → excitation → transducer → signal conditioning → ADC → digital analysis",
        "Accelerometers measure acceleration via the piezoelectric effect; their usable range extends to ~1/3 of their mounted resonant frequency",
        "The FRF H(ω) = X(ω)/F(ω) is the fundamental experimental result — magnitude reveals natural frequencies, phase confirms them, coherence validates data quality",
        "Impact hammer testing: roving hammer excites the structure at many DOFs; reciprocity H(i,j) = H(j,i) allows full modal matrix from one fixed response point",
        "Coherence γ²(ω) ≥ 0.9 is required for trustworthy FRF data — low coherence indicates noise, leakage, or nonlinearity",
        "Nyquist criterion: sample rate fₛ ≥ 2.56·f_max (not just 2×) to allow for anti-alias filter roll-off",
        "Windowing (Hann, flat-top) reduces spectral leakage; burst random excitation eliminates the need for windowing entirely",
        "Half-power bandwidth method: ζ ≈ (ωb − ωa)/(2ωₙ) extracts damping from the FRF width at the −3 dB points",
        "MAC (Modal Assurance Criterion) quantifies mode shape correlation: MAC=1 for identical shapes, MAC≈0 for orthogonal modes",
        "Campbell diagram maps resonance crossings between engine orders and structural natural frequencies as a function of operating speed",
      ]} />

      <h2 style={S.h2}>The Instrumentation Chain</h2>
      <p style={S.p}>
        A vibration measurement is only as good as its weakest link. The instrumentation chain stretches from the physical structure through the excitation source, transducer, signal conditioning, analogue-to-digital converter, and finally into digital signal processing software. Each stage has a finite bandwidth, dynamic range, and noise floor that limits the quality of the final result.
      </p>
      <DiagramInstrumentationChain />
      <Table2 rows={[
        ["Excitation strategies", "Impact hammer: broadband, simple, portable; limited force level\nElectrodynamic shaker: controlled waveform, high force, needs fixture\nHydraulic shaker: very high force, low-frequency capability\nAcoustic (speaker): non-contact, uniform pressure, limited amplitude"],
        ["Signal conditioning", "ICP/IEPE: constant-current supply (2–20 mA) powers sensor electronics\nCharge amplifier: converts piezoelectric charge to voltage (pC/V)\nAnti-aliasing filter: 4th-8th order low-pass, f_cutoff < fₛ/2.56\nAmplifier gain: set to use ≥80% of ADC range without clipping"],
        ["Analogue-to-digital", "Resolution: 16–24 bit → 96–144 dB dynamic range\nSample rate: typically 25.6 kHz for 10 kHz analysis\nSimultaneous sampling: all channels sampled at same instant (no skew)\nAnti-alias protection: hardware filter before ADC, not just software"],
        ["Dynamic range", "Ratio of largest to smallest detectable signal\nLimited by ADC bits at top and noise floor at bottom\n16-bit: ~96 dB; 24-bit: ~144 dB\nTrade: high gain for small signals but risk of overrange on large ones"],
        ["Trigger and synchronisation", "Impact test: pre-trigger (capture force rise); level trigger on force channel\nShaker test: run simultaneously, no trigger needed\nRPM reference: tachometer signal for order tracking in rotating machinery"],
      ]} />

      <h2 style={S.h2}>Vibration Transducers</h2>
      <p style={S.p}>
        The transducer is the most critical component in the chain — it determines what physical quantity is measured (displacement, velocity, or acceleration), the frequency range, dynamic range, and the degree of mass loading imposed on the test structure.
      </p>
      <DiagramSensors />
      <Table2 rows={[
        ["Piezoelectric accelerometer", "Principle: seismic mass compresses crystal → charge ∝ acceleration\nSensitivity: 1–1000 mV/g (higher = less noise, lower frequency)\nFrequency range: 0.5 Hz to 10 kHz (charge type); 2 Hz to 10 kHz (IEPE)\nNo DC response: cannot measure constant acceleration"],
        ["MEMS accelerometer", "Microfabricated capacitive sensing element\nDC-coupled: measures gravity and very low frequencies\nNoisier than piezo but tiny, cheap, and battery-powered\nUsed in consumer electronics, structural health monitoring"],
        ["Laser Doppler vibrometer (LDV)", "Measures surface velocity via Doppler shift of reflected laser\nNo mass loading — ideal for lightweight or rotating structures\nBandwidth: DC to >1 MHz; nm/s sensitivity\nScanning LDV: full-field mode shapes without contact"],
        ["Eddy current probe", "Non-contact displacement sensor via electromagnetic coupling\nDC-coupled: measures static and dynamic displacement\nRange: 0.25–5 mm gap; high resolution (0.1 µm)\nUsed for shaft orbits in rotating machinery (API 670)"],
        ["Force transducer", "Piezoelectric crystal in compression/shear measures force\nIntegrated into hammer tip or stinger between shaker and structure\nMeasures input force F(ω) for FRF computation H = X/F\nSensitivity: N/V; frequency range: DC to 10+ kHz"],
        ["Mounting methods", "Stud: highest resonant frequency (20+ kHz); permanent thread required\nAdhesive / wax: good to 5–10 kHz; easy, non-permanent\nMagnetic: quick attach; resonance ~2–4 kHz; ferrous surfaces only\nHand-held probe: < 1 kHz; variable contact → unrepeatable results"],
      ]} />

      <h2 style={S.h2}>Impact Hammer Testing</h2>
      <p style={S.p}>
        Impact (modal hammer) testing is the most widely used laboratory vibration test technique due to its simplicity, portability, and speed. A single technician can acquire a full set of FRFs across an entire structure in hours. The key skill is delivering clean, single impacts and choosing the correct tip to achieve the required frequency content without double-hitting.
      </p>
      <DiagramHammerTest />
      <Table2 rows={[
        ["Test configurations", "Roving hammer (fixed response): move hammer, keep accelerometer fixed\nRoving response (fixed input): move accelerometer, keep hammer fixed\nBoth valid by reciprocity; roving hammer preferred (fewer cable moves)\nFor operating deflection shapes: roving response with multiple references"],
        ["Free-free boundary condition", "Suspend structure on very soft elastic cords (bungee, elastic bands)\nRigid body modes should be < 1/10 of first flexible mode frequency\nSuspension frequency: fₛᵤₛₚ ≈ (1/2π)√(k_cord/M) — keep below 5 Hz\nSimulates free boundary condition assumed in analytical models"],
        ["Impact quality checks", "Single impact: only one force pulse visible in time record\nDouble hit: second pulse after short delay → corrupts spectrum\nOverload: ADC clips signal → discard immediately\nPre-trigger: capture 10–20 ms before impact to verify zero-noise floor"],
        ["Exponential window", "Applied to response only (not force) in impact testing\nForces response to decay to zero at end of record → eliminates leakage\nAdds artificial damping: subtract from measured ζ after fitting\nUsually: multiply response by e^(−αt), then subtract α from modal damping"],
        ["Number of averages", "3–5 averages per FRF minimum; 10–20 for noisy structures\nLinear average: reduces random noise by 1/√n factor\nRejection: discard records with overload, double-hit, or γ² < 0.9\nTime averaging requires stationary excitation — valid for impact testing"],
        ["Reciprocity verification", "Measure H(i,j) and H(j,i): results should agree within ±1 dB\nGood reciprocity confirms: linear system, correct calibration, negligible mass loading\nPoor reciprocity: indicates nonlinearity, mounting problem, or calibration error"],
      ]} />

      <h2 style={S.h2}>Frequency Response Functions</h2>
      <p style={S.p}>
        The Frequency Response Function is the central quantity in experimental structural dynamics. It relates the complex (amplitude and phase) output spectrum to the input spectrum at every frequency. Its magnitude reveals resonances; its phase indicates whether modes are in-phase or out-of-phase; its coherence validates measurement quality.
      </p>
      <DiagramFRF />
      <Table2 rows={[
        ["FRF definition", "H(ω) = X(ω)/F(ω)  for a linear time-invariant system\nX = response spectrum (displacement, velocity, or acceleration)\nF = force input spectrum\nReceptance: x/F; Mobility: v/F; Accelerance (inertance): a/F"],
        ["H₁ estimator", "H₁(ω) = S_xf(ω) / S_ff(ω)  (cross/auto-spectrum)\nMinimises effect of noise on the output (response) channel\nMost common estimator; slightly underestimates peak at resonance\nSxy = averaged cross-power spectrum; Sxx = averaged auto-spectrum"],
        ["H₂ estimator", "H₂(ω) = S_xx(ω) / S_fx(ω)\nMinimises effect of noise on the input (force) channel\nOverestimates peak slightly; useful when force measurement is noisy\n|H₁| ≤ |H_true| ≤ |H₂|  (H_true bounded between H₁ and H₂)"],
        ["Coherence function", "γ²(ω) = |S_xf|² / (S_ff · S_xx)   ∈ [0, 1]\nγ²=1: pure linear relationship between input and output\nγ²<1: noise, nonlinearity, leakage, or extraneous vibration sources\nTarget: γ²≥0.9 across frequency range of interest"],
        ["Natural frequency ID", "Peaks in |H(ω)| magnitude plot → candidates for natural frequencies\nPhase passes through −90° (or +90°) at each natural frequency\nNyquist plot (Im vs Re): circle diameter maximum at ωₙ\nPeak picking: quick but inaccurate for closely spaced modes"],
        ["Damping from FRF", "Half-power (−3 dB) bandwidth: ζ = (ωb−ωa)/(2ωₙ)\nCircle fit (Kennedy-Pancu): fit circle to Nyquist plot\nRational fraction polynomial: global fit to all resonances simultaneously\nFrom log decrement (time domain): ζ = δ/(2π), δ = ln(xₙ/xₙ₊₁)"],
        ["Nyquist circle properties", "SDOF FRF near resonance traces a circle in the Im–Re plane\nCircle diameter D = 1/(2ζωₙ²m) — determines modal mass & damping\nResonance at point of maximum arc-length rate with frequency\nModal constant = residue at pole; indicates strength of mode at DOF"],
        ["Driving point FRF", "Measured at same DOF as excitation force (collocated)\nNecessary condition: peaks and troughs must alternate (interlacing property)\nViolation of interlacing → data quality problem or unmeasured mode\nRequired for mass-normalised mode shapes in SDOF circle fit"],
      ]} />

      <h2 style={S.h2}>Modal Analysis and Mode Shapes</h2>
      <p style={S.p}>
        Modal analysis extracts the modal parameters — natural frequencies, damping ratios, and mode shapes — from a set of measured FRFs. This process, called modal parameter estimation or curve fitting, fits a mathematical model of superposed SDOF systems to the measured data. The result is a validated modal model that can be used for structural modification prediction, model updating, and structural health monitoring.
      </p>
      <DiagramModalAnalysis />
      <Table2 rows={[
        ["Modal model", "H(ω) = Σₙ [φᵢⱼ φᵢₖ / (ωₙᵣ² − ω² + 2jζᵣωₙᵣω)]\nEach term is one mode's contribution to H between DOFs j and k\nφᵢⱼ = r-th mode shape value at DOF j (spatial pattern)\nωₙᵣ, ζᵣ = r-th natural frequency and damping ratio"],
        ["Peak picking method", "Identify peaks in summed FRF or peak-indicator function\nRead off ωₙ at each peak; compute ζ from half-power bandwidth\nSimple and fast; inaccurate for closely spaced or highly damped modes\nGood starting point for more refined curve fitting"],
        ["SDOF circle fit (Kennedy-Pancu)", "Fit circle to Nyquist plot near each resonance\nExtract ωₙ from point of maximum sweep rate on circle\nDamping: ζ = (ω₂−ω₁)/(2ωₙ·tan(θ/2)) where θ is arc angle\nModal constant from circle diameter and mass normalisation"],
        ["MDOF global fitting", "Fit all modes simultaneously across all measured FRFs\nRational fraction polynomial (RFP): minimises difference between measured and analytical H(ω)\nPolyreference: uses multiple reference DOFs → resolves repeated roots\nLSCE, ERA, PRCE: time-domain methods using impulse response functions"],
        ["Mode shapes", "φᵣ = {φᵣ₁, φᵣ₂, …, φᵣₙ}ᵀ: relative displacements at each DOF\nObtained from residues of the partial fraction expansion of H\nMass normalised: φᵣᵀMφᵣ = 1; then φᵣᵀKφᵣ = ωₙᵣ²\nAnimate mode shapes to visualise structural deformation patterns"],
        ["MAC matrix", "MACᵢⱼ = |φᵢᵀφⱼ|² / (φᵢᵀφᵢ · φⱼᵀφⱼ)   ∈ [0,1]\nMACᵢᵢ = 1 (mode with itself); MACᵢⱼ ≈ 0 (independent modes)\nOff-diagonal values > 0.1 suggest spatial aliasing or insufficient DOFs\nCompare experimental to FE mode shapes for model validation"],
        ["Modal mass & stiffness", "Modal mass: mᵣ = 1/(φᵣᵀ·2ωₙᵣ·Im(H at ωₙᵣ)) — from driving point FRF\nModal stiffness: kᵣ = ωₙᵣ²·mᵣ\nRequired for structural modification prediction (Sherman-Morrison formula)\nFull set of [M], [K], [C] can be assembled from all modal parameters"],
        ["Structural modification", "Predict new frequencies after adding mass or stiffness\nΔωₙ² ≈ −ωₙᵣ²·(Δm·φᵣᵢ²/mᵣ)  (adding mass at DOF i)\nSensitivity: ∂ωₙ²/∂mᵢ = −ωₙᵣ²φᵣᵢ²/mᵣ;  ∂ωₙ²/∂kᵢⱼ = (φᵣᵢ−φᵣⱼ)²/mᵣ"],
      ]} />

      <h2 style={S.h2}>Signal Processing for Vibration Data</h2>
      <p style={S.p}>
        Raw sampled data must pass through a chain of digital signal processing operations before FRFs can be computed. Each step — windowing, FFT, cross-spectrum averaging — involves approximations and trade-offs that the engineer must understand and control to ensure valid results.
      </p>
      <DiagramSignalProcessing />
      <Table2 rows={[
        ["Discrete Fourier Transform", "X[k] = Σₙ x[n]·e^(−j2πkn/N)  for k=0,1,…,N−1\nFrequency resolution: Δf = fₛ/N\nComputational FFT algorithm: O(N log N) vs. O(N²) for DFT\nResult: complex spectrum; magnitude and phase at discrete frequencies"],
        ["Spectral leakage", "Occurs when signal frequency is not a multiple of Δf\nResults in energy 'leaking' from true frequency into adjacent bins\nSolution: window function or burst random excitation\nWindow trade-off: main lobe width vs. side-lobe level"],
        ["Window functions", "Rectangular: best frequency resolution, worst leakage (use with burst random)\nHann: general purpose, −32 dB side lobes, 1.5-bin main lobe\nHamming: −43 dB side lobes, smoother roll-off\nFlat-top: best amplitude accuracy (±0.01 dB), poor resolution — use for calibration\nExponential: applied to response in impact tests to force decay"],
        ["Averaging", "Linear (synchronous): averages N complex spectra → reduces noise by √N\nRMS (power): averages |X|² → removes phase; use for PSD estimation\nTime-domain: averages triggered time records → removes asynchronous noise\nPeak-hold: retains maximum at each frequency — used for sine sweeps"],
        ["Cross-power spectrum", "S_xy(ω) = X*(ω)·Y(ω)  averaged over n records\nComplex quantity: magnitude is correlation strength, phase is relative phase\nH₁ = S_xy/S_xx;  requires X = force, Y = response\nAveraging reduces variance: σ²(H₁) ∝ (1−γ²)/(n·γ²)"],
        ["Zoom FFT", "Compute high-resolution spectrum over a narrow frequency band\nEquivalent to band-pass filtering + decimation before FFT\nAchieves fine Δf without requiring enormous N for full bandwidth\nUseful for closely spaced modes that cannot be resolved at normal resolution"],
        ["Order tracking", "Resample time data at fixed increments of shaft angle (not time)\nConverts RPM-dependent peaks to fixed-order lines in spectrum\nAngle-domain averaging removes random vibration; amplifies orders\nRequired for rotating machinery where speed varies during test"],
      ]} />

      <h2 style={S.h2}>Shaker Testing and Excitation Signals</h2>
      <p style={S.p}>
        Electrodynamic shakers provide controlled, repeatable excitation at precise amplitude and frequency. The choice of excitation signal — swept sine, broadband random, burst random, or pseudo-random — profoundly affects test duration, signal-to-noise ratio, and susceptibility to leakage errors.
      </p>
      <DiagramShakerTest />
      <Table2 rows={[
        ["Electrodynamic shaker", "Voice coil in magnetic field: F = BIL (force ∝ current)\nFrequency range: 5 Hz to 10 kHz (standard); 2 Hz to 20 kHz (high-performance)\nStinger coupling: thin rod between shaker and structure — transmits axial force only\nForce gauge between stinger and structure measures actual input force"],
        ["Swept sine", "f(t) = A·sin(2π·[f₀+(f₁−f₀)t/(2T)]·t)\nLinear sweep: constant Δf per unit time\nLogarithmic sweep: constant octaves per minute — equal time per mode\nSweep rate rule: ≤ Δf²_resolution / 3 (allow steady state to establish)"],
        ["Broadband random", "White noise: flat PSD from 0 to fₛ/2\nBand-limited white noise: PSD flat over [f₁, f₂] only\nAdvantage: all frequencies simultaneously; fast acquisition\nAverage multiple records: reduces noise variance ∝ 1/n"],
        ["Burst random", "Random signal occupies only first fraction T_burst of record\nStructure rings down to zero in remaining T−T_burst portion\nNo leakage even with rectangular window — response naturally ends\nDefault choice for most experimental modal analysis work"],
        ["Pseudo-random", "Periodic signal with flat spectrum: deterministic sum of sine waves\nPeriodic: exactly repeats each record → zero leakage with rectangular window\nDisadvantage: cannot detect nonlinearities (system sees same signal)\nUseful for linear FRF estimation on nonlinear structures (linearised result)"],
        ["Chirplet / impact shaker", "Very short broadband burst from shaker — similar to hammer but controllable\nHigher and more repeatable force levels than manual hammer\nUsed for very heavy structures or when automation is needed\nAutomatic trigger and averaging possible"],
        ["Shaker fixturing", "Fixture must be stiffer than structure in test band\nFixture modes above 3× maximum test frequency\nCheck fixture FRF with stinger attached but structure absent\nMass of fixture should be << modal mass of structure"],
      ]} />

      <h2 style={S.h2}>Vibration Metrics and Standards</h2>
      <p style={S.p}>
        Measured vibration data must be reduced to a small number of scalar metrics that can be compared against acceptance criteria and standards. The choice of metric — peak, RMS, PSD — depends on the failure mechanism: fatigue is driven by RMS, clearance by peak, and resonance risk by peak frequency content.
      </p>
      <DiagramMetrics />
      <Table2 rows={[
        ["RMS velocity", "Most common overall machinery vibration metric\nISO 10816-3: overall rms velocity in mm/s (10–1000 Hz)\nZone A (<2.3 mm/s): new machines; Zone D (>7.1 mm/s): dangerous\nFilter to 10–1000 Hz: removes DC drift and high-frequency noise"],
        ["Displacement (pk-pk)", "Used for shaft vibration monitoring in fluid-film bearings\nISO 7919: shaft relative displacement in µm peak-to-peak\nAPI 670: proximity probe alarms and trips for rotating machinery\nOrbit plot: X–Y displacement traces shaft centreline path"],
        ["Acceleration (g rms)", "Used for high-frequency and shock assessment\nIATA / aircraft: g rms limits for avionics qualification\nMIL-STD-810G: random vibration test levels in g²/Hz (PSD)\nShock response spectrum (SRS): severity of transient events"],
        ["Power Spectral Density", "S(f) [g²/Hz or (m/s²)²/Hz]: energy per unit frequency bandwidth\nArea under PSD = total mean-square value (Parseval's theorem)\nUsed to specify random vibration test environments\nNarrow-band vs. broadband: compare individual peak to total background"],
        ["Fatigue damage spectrum", "Accumulates damage: D = Σ(nᵢ/Nᵢ)  (Miner's rule)\nCounts stress cycles at each amplitude and compares to S-N curve\nRainflow counting algorithm identifies complete stress cycles in random data\nVibration fatigue: combine PSD with S-N curve → predicted lifetime"],
        ["Campbell diagram use", "Maps vibration amplitude vs. frequency vs. operating speed (RPM)\nEngine orders: 1×, 2×, 3×, … times shaft frequency\nCrossing: order line intersects structural resonance → potential damage\nMitigation: detune resonance by design, or add damping at crossing RPM"],
        ["ISO calibration standards", "ISO 5347-1: voltage sensitivity method using back-to-back comparison\nISO 5348-1: mechanical coupling for accelerometer calibration\nISO 16063-1: primary calibration by laser interferometry (reference standard)\nANNUAL recalibration required for traceable measurements"],
      ]} />

      <h2 style={S.h2}>Errors, Calibration, and Quality Assurance</h2>
      <p style={S.p}>
        Reliable vibration data requires systematic attention to error sources at every stage of the measurement chain. A methodical pre-test check procedure, in-test quality indicators (coherence, linearity checks), and post-test validation (reciprocity, consistency between runs) are all necessary for data that can support engineering decisions.
      </p>
      <DiagramCalibration />
      <Table2 rows={[
        ["Pre-test checklist", "Verify sensor calibration certificate is current (≤ 12 months)\nCheck cable integrity: resistance, insulation, and connector seating\nSet correct gain: signal occupies 70–90% of ADC range on excitation\nConfirm anti-alias filter is active and set correctly\nCheck structure suspension frequency (free-free) < 1/10 of first mode"],
        ["In-test quality indicators", "Coherence ≥ 0.9 across frequency range of interest\nReciprocity: H(i,j) ≈ H(j,i) within ±1 dB / ±5°\nDriving-point FRF: peaks and troughs alternate (interlacing)\nLinear check: FRF unchanged when force amplitude doubled\nNo overloads: inspect time records for clipping artefacts"],
        ["Noise floor check", "Measure spectrum with structure at rest (ambient noise)\nSignal-to-noise ratio: FRF peak should be > 20 dB above noise floor\nIf SNR insufficient: increase excitation force, add averages, or improve isolation\nCoherence naturally low where SNR < 10 dB"],
        ["Mass loading correction", "Measure FRF with sensor at test point and with sensor removed (half-power from adjacent)\nForrester-Bishop correction: shift frequency analytically\nOr: use lighter sensor or non-contact LDV to avoid the problem entirely\nQuick check: sensor mass < 1% of local modal mass → correction negligible"],
        ["Post-test validation", "Reconstruct synthesised FRF from extracted modal parameters\nOverlay measured vs. synthesised: match confirms correct modal identification\nCompute MAC between extracted modes: diagonal ≥ 0.9\nPerform independent repeat test: reproducibility within ±2 Hz and ±10% damping"],
        ["Uncertainty quantification", "Type A: statistical (repeatability of multiple measurements)\nType B: systematic (calibration uncertainty, resolution, quantisation)\nCombined uncertainty: u_c = √(u_A² + u_B²)\nExpanded uncertainty: U = k·u_c (k=2 for 95% confidence interval)"],
      ]} />

      <InfoBox title="Key Formulae Summary" items={[
        "FRF: H(ω) = X(ω)/F(ω);   H₁ = Sxf/Sff;   H₂ = Sxx/Sfx;   Coherence: γ² = |Sxf|²/(Sff·Sxx)",
        "Half-power bandwidth: ζ ≈ (ωb−ωa)/(2ωₙ);   Log decrement: ζ = δ/(2π) = ln(xₙ/xₙ₊₁)/(2π)",
        "Nyquist: fₛ ≥ 2·f_max;   Freq. resolution: Δf = fₛ/N;   Anti-alias: f_cutoff < fₛ/2.56",
        "RMS: x_rms = √(1/N·Σxᵢ²);   Crest factor = x_peak/x_rms;   PSD: S_xx = |X|²/T",
        "MAC: MACᵢⱼ = |φᵢᵀφⱼ|²/(φᵢᵀφᵢ·φⱼᵀφⱼ);   Modal: H = Σ φᵣφᵣᵀ/(ωₙᵣ²−ω²+2jζᵣωₙᵣω)",
        "ZOH discretisation: Φ=eᴬᵀ;   Mass loading: Δfₙ/fₙ ≈ −m_sensor/(2·M_modal)",
        "Swept sine rate: ≤ Δf²/3;   Burst random duty cycle: T_burst/T_record ≈ 0.5–0.75",
        "Campbell order: f_order = n·RPM/60;   Resonance crossing at RPM = fₙ·60/n (nth order)",
      ]} />
    </div>
  );
}